
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("5l7l5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $3e349b4b15bbaf2e$var$_jquery = $3e349b4b15bbaf2e$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $3e349b4b15bbaf2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// ====================================================================================
// stickyDonation.module
// ====================================================================================
var $3e349b4b15bbaf2e$var$scrollStart = document.querySelector(".header") ? document.querySelector(".header").offsetHeight : 7;
var $3e349b4b15bbaf2e$var$stickyDonation = {
    elem: document.querySelector(".sticky-donation"),
    staticContent: document.querySelector(".sticky-donation .static-content"),
    logo: document.querySelector(".sticky-donation .image-floated--2"),
    decor: document.querySelector(".sticky-donation .decor-3"),
    offsetTop: 0,
    sticky: true
};
var $3e349b4b15bbaf2e$var$updateImageHeight = function updateImageHeight() {
    if (!$3e349b4b15bbaf2e$var$stickyDonation.staticContent || !$3e349b4b15bbaf2e$var$stickyDonation.logo) return;
    var sContentHeight = $3e349b4b15bbaf2e$var$stickyDonation.staticContent.offsetHeight;
    $3e349b4b15bbaf2e$var$stickyDonation.logo.style.height = sContentHeight + "px";
};
/**
 * Set offset of the next sibling element + padding bottom of the sticky donation element
 * Checks at first if the next element exists and is type of ELEMENT_NODE
 * (https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node.element_node
 */ function $3e349b4b15bbaf2e$var$setStickyDonationOffset() {
    var elem = $3e349b4b15bbaf2e$var$stickyDonation.elem;
    var offset = 0;
    var elHeight = elem.offsetHeight;
    var tMargin = window.getComputedStyle($3e349b4b15bbaf2e$var$stickyDonation.elem).marginTop;
    tMargin = parseInt(tMargin.replace("px", ""));
    var bMargin = window.getComputedStyle($3e349b4b15bbaf2e$var$stickyDonation.elem).marginBottom;
    bMargin = parseInt(bMargin.replace("px", ""));
    var donationHeight = document.querySelector(".sticky-donation .donation").offsetHeight;
    var $nextElem = (0, $3e349b4b15bbaf2e$var$_jquery["default"])(elem).next();
    if ($nextElem.get(0) && $nextElem.get(0).nodeType === 1) offset = $nextElem.offset().top - bMargin - elHeight + donationHeight;
    $3e349b4b15bbaf2e$var$stickyDonation.offsetTop = offset;
}
var $3e349b4b15bbaf2e$var$handleStickyDonation = function handleStickyDonation(sc) {
    if (sc <= $3e349b4b15bbaf2e$var$scrollStart) {
        (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).removeClass("sticky");
        $3e349b4b15bbaf2e$var$stickyDonation.sticky = false;
        (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).addClass("init");
        return;
    } else (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).addClass("init");
    var stickyPoint = $3e349b4b15bbaf2e$var$stickyDonation.offsetTop;
    var scrollHeight = sc + window.innerHeight;
    if (scrollHeight > stickyPoint && $3e349b4b15bbaf2e$var$stickyDonation.sticky) {
        (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).removeClass("sticky");
        $3e349b4b15bbaf2e$var$stickyDonation.sticky = false;
    } else if (scrollHeight <= stickyPoint && !$3e349b4b15bbaf2e$var$stickyDonation.sticky) {
        (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).addClass("sticky");
        $3e349b4b15bbaf2e$var$stickyDonation.sticky = true;
    }
};
var $3e349b4b15bbaf2e$var$init = module.exports.init = function init() {
    var attempts = 0;
    var notSticky = $3e349b4b15bbaf2e$var$stickyDonation.elem.classList.contains("not-sticky");
    var noDecor = !$3e349b4b15bbaf2e$var$stickyDonation.decor;
    if (notSticky) (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).addClass("init");
    else (0, $3e349b4b15bbaf2e$var$_jquery["default"])($3e349b4b15bbaf2e$var$stickyDonation.elem).removeClass("init");
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            if (notSticky && noDecor) {
                $3e349b4b15bbaf2e$var$updateImageHeight();
                (0, $3e349b4b15bbaf2e$var$_jquery["default"])(window).on("resize", function(e) {
                    $3e349b4b15bbaf2e$var$updateImageHeight();
                });
            } else {
                $3e349b4b15bbaf2e$var$setStickyDonationOffset();
                setTimeout(function() {
                    return $3e349b4b15bbaf2e$var$setStickyDonationOffset();
                }, 500);
                var bsc = window.scrollY || window.pageYOffset;
                $3e349b4b15bbaf2e$var$handleStickyDonation(bsc);
                if (noDecor) $3e349b4b15bbaf2e$var$updateImageHeight();
                (0, $3e349b4b15bbaf2e$var$_jquery["default"])(window).on("scroll", function(e) {
                    var sc = window.scrollY || window.pageYOffset;
                    $3e349b4b15bbaf2e$var$handleStickyDonation(sc);
                });
                (0, $3e349b4b15bbaf2e$var$_jquery["default"])(window).on("resize", function(e) {
                    if (noDecor) $3e349b4b15bbaf2e$var$updateImageHeight();
                    if ($3e349b4b15bbaf2e$var$stickyDonation) $3e349b4b15bbaf2e$var$setStickyDonationOffset();
                });
            }
        } else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=donationSticky.module.11210450.js.map
